import { message } from "antd";
import { call, put, takeLatest } from "redux-saga/effects";
import { addNetworksApi, deleteNetworksApi, editNetworksApi, getNetworksApi } from "../../../services/api/network";
import { addNetworks, deleteNetwork, editNetwork, setLoading, setNetworks } from "../../actions/networks";

import i18next from "i18next";

function* getNetworksAsync() {
  try {
    let loading = true;
    yield put(setLoading(loading));
    const response = yield call(getNetworksApi);
    const { data } = response;
    if (data) {
      yield put(setNetworks(data));
      message.success(i18next.t("admin.networks.server.success"));
    } else {
      message.error("Erreur : " + response.statusText, {
        position: "bottom-right",
        autoClose: 2000,
      });
      window.location.replace("/home-sso");
    }
  } catch (e) {
    console.error(e);
  }

  yield put(setLoading(false));
}

function* editNetworkAsync({ data: { id, body, redirection } }) {
  try {
    yield put(setLoading(true));
    const { data, response } = yield call(editNetworksApi, id, body);

    if (!response) {
      message.error(i18next.t("admin.networks.edit.server.error"));
      throw new Error("error");
    }

    if (response.ok) {
      yield put(editNetwork(data));
      message.success(i18next.t("admin.networks.edit.server.success"));
      redirection();
    } else {
      message.error("Erreur : " + response.statusText);
    }
  } catch (e) {
    console.error(e);
  }
  yield put(setLoading(false));
}

function* addNetworkAsync({ data: { body, redirection } }) {
  try {
    yield put(setLoading(true));
    const { data, response } = yield call(addNetworksApi, body);

    if (!response) {
      message.error(i18next.t("admin.networks.add.server.error"));
      throw new Error("error");
    }

    if (response.ok) {
      yield put(addNetworks(data));
      message.success(i18next.t("admin.networks.add.server.success"));
      if (redirection) {
        redirection();
      }
    } else {
      message.error("Erreur : " + response.statusText);
    }
  } catch (e) {
    console.error(e);
  }
  yield put(setLoading(false));
}

function* deleteNetworkAsync({ data: { id } }) {
  try {
    yield put(setLoading(true));
    const { response } = yield call(deleteNetworksApi, id);
    if (response.ok) {
      yield put(deleteNetwork({ id }));
      message.success(i18next.t("admin.networks.delete.server.success"));
    } else {
      message.error("Erreur : " + response.statusText);
    }
  } catch (e) {
    console.error(e);
  }
  yield put(setLoading(false));
}

export function* networksSaga() {
  yield takeLatest("GET_NETWORKS", getNetworksAsync);
}

export function* editNetworkSaga() {
  yield takeLatest("EDIT_NETWORKS_REQUEST", editNetworkAsync);
}

export function* addNetworkSaga() {
  yield takeLatest("ADD_NETWORKS_REQUEST", addNetworkAsync);
}

export function* deleteNetworkSaga() {
  yield takeLatest("DELETE_NETWORKS_REQUEST", deleteNetworkAsync);
}
